var LightboxUtils = (function() {
	  'use strict';
	
	  var lightboxUtils = {};
	
	  var generateItems = function(el){
		var items = [];
		var urlsEl = jQuery(el).data('urls');
		if (urlsEl) {
		  var urls = jQuery(urlsEl).data('url')
		  if (urls) {
			urls = urls.split(',');
			var d = jQuery(el).data('description')||'';
	
			d = d.split(',');
			urls.forEach(function(u , i) {
			  var title = d[i] || '';
			  items.push({src: u, title: title});
			});
		  }
		}
		return items;
	  }
	
	  lightboxUtils.bindMagnificPopup = function(parent = jQuery(document)) {
		parent.find('.js-asset-popup-images').each(function(){
		  jQuery(this).magnificPopup({
			items: generateItems(this),
			gallery: {
			  enabled: true
			},
			type: 'image' // this is a default type
		  });
		});
		
		parent.find('.js-asset-popup-carousel').magnificPopup({
		  disableOn: 0,
		  type: 'image',
		  gallery: {
			  enabled: true
			},
		  mainClass: 'mfp-fade mfp-full'
		});
	
		parent.find('.js-asset-popup-video').magnificPopup({
		  disableOn: 0,
		  type: 'iframe',
		  mainClass: 'mfp-fade',
		  removalDelay: 160,
		  preloader: false,
	
		  fixedContentPos: false
		});
		
		parent.find('.js-asset-popup-hosted_video').magnificPopup({
		  disableOn: 0,
		  type: 'inline',
		  mainClass: 'mfp-fade',
		  removalDelay: 160,
		  preloader: false,
		  showCloseBtn: true,
		  callbacks: {
			open: function() {
				
				var player = new MediaElementPlayer('video.hosted-video__player');
				player.play(); 
			  }
		  },
		  fixedContentPos: false
		});
	  }
	  
	  return lightboxUtils;
	})();
	
	
	(function() {
	  LightboxUtils.bindMagnificPopup();
	})();